import React from 'react';
import Navbar from '../components/Navbar';
import HeroBanner from '../components/HeroBanner';
import CompanyIntro from '../components/CompanyIntro';
import DivisionsOverview from '../components/DivisionsOverview';
import ImpactNumbers from '../components/ImpactNumbers';
import Testimonials from '../components/Testimonials';
import WhyChooseUs from '../components/WhyChooseUs';
import CoreValues from '../components/CoreValues';
import CallToAction from '../components/CallToAction';
import FounderMessage from '../components/FounderMessage';
import Footer from '../components/Footer';

function Home() {
  return (
    <>
      <Navbar />
      <HeroBanner />
      <CompanyIntro />
      <DivisionsOverview />
      <WhyChooseUs />
      <CoreValues />
      <ImpactNumbers />
      <Testimonials />
      <CallToAction />
      <Footer />
    </>
  );
}

export default Home;
